<section>
    <div class="columns height-full">
      <div class="column is-4 height-full p-0">
        <div class="form-part">
          <img ngSrc="/assets/logo2-fuchs.png" alt="fuchs-logo" width="300" height="150" priority="true"/>
          <form [formGroup]="loginForm" (ngSubmit)="onLogin()">
            @if (hasErrorLogin && !isLoading) {
                <div class="notification is-danger">
                  <button class="delete" (click)="closeNotification()"></button>
                  Usuario y/o password incorrectos.
                </div>

            }
            <div class="field">
              <label class="label">Correo electrónico</label>
              <div class="control">
                <input class="input" type="text" placeholder="Correo electrónico" formControlName="email">
              </div>
            </div>
            <div class="field mt-4">
              <label class="label">Contraseña</label>
              <div class="control">
                <input class="input" type="password" placeholder="Contraseña" formControlName="password">
              </div>
            </div>
            <button type="submit" class="button is-primary is-fullwidth mt-5" [disabled]="!loginForm.valid">
            @if (!isLoading) {
                <span>Acceder</span>
            }@else {
              <fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>
            }
            </button>
          </form>
        </div>
      </div>
      <div class="column is-8 image-login height-full">
      </div>
    </div>
  </section>